<template>
  <div class="header-desktop">
    <div class="balance-group">
      <AccountBalance v-if="!getUserInfo.organizationId" />
    </div>
    <div class="actions-group">
      <HeaderSearch v-if="!hideSearch" />
      <Notifications />
      <UserProfile />
      <Divider type="vertical" class="divider" />
      <AccentButton
        @click="openCreateOrderPopup"
      >
        <PlusIcon color="white" class="mr-2" />
        Створити замовлення
      </AccentButton>
      <CreateOrderPopup ref="createOrderPopup" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CreateOrderPopup from '../../create-order-popup';
import HeaderSearch from './header-search';
import { AccountBalance } from '@/features/account-balance';
import { Notifications } from '@/features/server-notifications';
import { UserProfile } from '@/features/user-profile';
import { Env } from '@/shared/config/environment';
import { Divider } from '@/shared/ui/divider';
import { AccentButton } from '@/shared/ui/form';
import { PlusIcon } from '@/shared/ui/icons';

export default {
  components: { HeaderSearch, AccentButton, PlusIcon, AccountBalance, Divider, Notifications, UserProfile,
    CreateOrderPopup },
  computed: {
    ...mapGetters('currentUserModule', ['getUserInfo']),
    hideSearch() { return Env.features.hideSearch; },
  },
  methods: {
    openCreateOrderPopup() {
      this.$refs.createOrderPopup.open();
    },
  },
};
</script>

<style lang="scss" scoped>
.header-desktop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /*padding: 32px 24px 23px 24px;*/
  padding: 15px 24px;
}

.actions-group {
  display: flex;
  align-items: center;
}

.divider {
  height: 50px;
}
</style>
